function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("line", {
  x1: 5.25,
  y1: 6.25,
  x2: 10.75,
  y2: 6.25,
  stroke: "#0057FF",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 5.25,
  y1: 10.25,
  x2: 10.75,
  y2: 10.25,
  stroke: "#0057FF",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 5.25,
  y1: 14.25,
  x2: 15.75,
  y2: 14.25,
  stroke: "#0057FF",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 5.25,
  y1: 18.25,
  x2: 15.75,
  y2: 18.25,
  stroke: "#0057FF",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 8,
  r: 4.45,
  stroke: "#0057FF",
  strokeWidth: 1.1
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 9.99998C16.5 9.99998 19.5 11.5 19.5 9.49999C19.5 7.69721 16.5 8.58111 16.5 6.99999C16.5 5.49999 18.5 5.5 19.5 6.5",
  stroke: "#0057FF",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18 11L18 5",
  stroke: "#0057FF",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.8134 2L2 2C1.44772 2 1 2.44772 1 3V21C1 21.5523 1.44772 22 2 22H20C20.5523 22 21 21.5523 21 21V13.7358C20.6273 13.2147 20.1135 13.0547 19.7 13.5454V20.7H2.3V3.3H13.8253C14.8576 2.73829 14.5455 2.30388 13.8134 2Z",
  fill: "#0057FF"
});
const SvgPostpaidBill = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPostpaidBill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/postpaid-bill.2faa13c8.svg";
export { ForwardRef as ReactComponent };